
import React, { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import "../Tours/tour.css";
import {
  Container,
  Row,
  Nav,
  Col,
  Tab,
  ListGroup,
  Card,
  Stack,
} from "react-bootstrap";
import { doc, getDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import ImageGallery from "react-image-gallery";
import { Helmet } from "react-helmet-async";

const TourDetails = () => {
  const { id } = useParams();
  const [tour, setTour] = useState(null);

  const fetchTour = async () => {
    try {
      const docRef = doc(fireDB, "tours", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setTour({ id: docSnap.id, ...docSnap.data() });
      } else {
        alert("Tour not found");
      }
    } catch (error) {
      console.error("Error loading tour:", error);
    }
  };

  useEffect(() => {
    fetchTour();
    window.scrollTo(0, 0);
  }, []);

  if (!tour) return <p className="text-center py-5">Loading tour details...</p>;

  return (
    <>
      <Helmet>
        <title>
          {tour?.title
            ? `${tour.title} | Shivay Tour and Travells`
            : "Tour Details | Shivay Tour and Travells"}
        </title>

        <meta
          name="description"
          content={
            tour?.description
              ? `Book ${tour.title} with Shivay Tour and Travells. ${tour.description.slice(
                0,
                150
              )}`
              : "Book exciting tours with Shivay Tour and Travells. Explore destinations, packages, and more."
          }
        />

        <link
          rel="canonical"
          href={
            tour?.id
              ? `https://www.shivaytourandtravells.com/tours/${tour.id}`
              : "https://www.shivaytourandtravells.com/tours"
          }
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "TouristTrip",
              name: tour?.title || "Tour Package",
              description:
                tour?.description || "Tour description not available.",
              touristType: "Travelers",
              touristDestination: tour?.location || "India",
              offers: {
                "@type": "Offer",
                price: tour?.afterDiscount || tour?.price || "N/A",
                priceCurrency: "INR",
                url: tour?.id
                  ? `https://www.shivaytourandtravells.com/tours/${tour.id}`
                  : "https://www.shivaytourandtravells.com/tours",
              },
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: tour?.rating || "5.0",
                reviewCount: tour?.reviews || "0",
              },
            }),
          }}
        />
      </Helmet>


      <Breadcrumbs
        title={tour.title}
        pagename={<NavLink to="/tours">Tours</NavLink>}
        childpagename={tour.title}
      />

      <section className="tour_details py-5">
        <Container>
          <Row>
            <h1 className="fs-2 font-bold mb-4">{tour.title}</h1>

            <ImageGallery
              items={[{
                original: tour.imageUrl || tour.image,
                thumbnail: tour.imageUrl || tour.image,
              }]}
              showNav={false}
              showBullets={false}
              showPlayButton={false}
            />

            <Tab.Container id="left-tabs-example" defaultActiveKey="1">
              <Row className="py-5">
                <Col md={8}>
                  <Nav variant="pills" className="flex-row nav_bars rounded-2">
                    <Nav.Item><Nav.Link eventKey="1">Overview</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="2">Itinerary</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="3">Inclusions</Nav.Link></Nav.Item>
                  </Nav>

                  <Tab.Content className="mt-4">
                    <Tab.Pane eventKey="1">
                      <h3>Overview</h3>
                      <p>{tour.description || "No overview available."}</p>
                      <p><strong>Days:</strong> {tour.days || "N/A"}</p>
                      <p><strong>Location:</strong> {tour.location}</p>
                    </Tab.Pane>

                    <Tab.Pane eventKey="2">
                      <h3>Itinerary</h3>
                      <p>{tour.itinerary || "Itinerary content not available."}</p>
                    </Tab.Pane>

                    <Tab.Pane eventKey="3">
                      <h3>Included Services</h3>
                      <ul>
                        {(Array.isArray(tour.inclusions) ? tour.inclusions : (tour.inclusions || "").split(',')).map((item, index) => (
                          <li key={index}>{item.trim()}</li>
                        ))}
                      </ul>

                    </Tab.Pane>
                  </Tab.Content>
                </Col>

                <Col md={4}>
                  <Card className="rounded-3 p-2 shadow-sm mb-4 price-info">
                    <Card.Body>
                      <Stack gap={2} direction="horizontal">
                        <h1 className="font-bold mb-0 h2">
                          ₹{tour.afterDiscount || tour.price || 'N/A'}
                        </h1>
                        <span className="fs-4">/Book Now</span>
                      </Stack>

                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <ListGroup horizontal>
                          <ListGroup.Item className="border-0 me-2 fw-bold">
                            {tour.rating || "5.0"}
                          </ListGroup.Item>
                          <ListGroup.Item className="border-0 text-warning">
                            <i className="bi bi-star-fill"></i>
                          </ListGroup.Item>
                        </ListGroup>
                        <h5 className="h6">({tour.reviews || "0"})</h5>
                      </div>

                      <NavLink to={`/booking/${tour.id}`} className="primaryBtn w-100 text-center fw-bold">
                        Book Now
                      </NavLink>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Tab.Container>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TourDetails;
